export default "__VITE_ASSET__CP8bbk7O__"